import { cn } from "@newxsystems/shared";
import type { IWohaSectionProps } from "./WohaSection.props";

export const WohaSection = ({
  children,
  className,
  containerWidth = "default",
  id,
  spacing,
}: IWohaSectionProps) => (
  <section
    className={cn("woha-block-spacing", className)}
    data-spacing={spacing || undefined}
    id={id || undefined}
  >
    <div className="container" data-container-width={containerWidth}>
      {children}
    </div>
  </section>
);
WohaSection.displayName = "Content::WohaSection";
